import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fxRateType'
})
@Injectable({
    providedIn: 'root'
})
export class FxRateTypePipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        switch (value) {
            case 'avg_1m':
                return '1 month avg.';

            case 'avg_3m':
                return '3 month avg.';

            case 'avg_6m':
                return '6 month avg.';

            case 'avg_12m':
                return '12 month avg.';

            default:
                return value;
        }
    }
}
